import React from 'react';
import Lottie from "lottie-react";
import logo from "../animations/logo_loader.json"

function Loader() {
    return (
        <div className='loader-frame'>
            <Lottie className='loader' animationData={logo} loop={true} />
        </div>
    );
}


export default Loader;